import type { Simplify } from 'type-fest';

import type { ProjectsFilter, ReleaseGroupsFilter } from './filters';
import type { ProjectsSort, ReleaseGroupsSort } from './sorting';

export type ProjectsByLocatorsQuery = {
  locators: string[];
};

export type ReleaseGroupsByIdQuery = {
  ids: number[];
}

export const COUNT_DEFAULT = 10;
export const COUNT_MIN = 1;

// COUNT has a different maximum on backend and frontend because the frontend should only
// allow the rendering of COUNT_MAX_FE projects at a time, but the backend should be able
// to respond with more projects if requested.
export const COUNT_MAX_FE = 50;
export const COUNT_MAX_BE = 1000;

export const PAGE_DEFAULT = 1;
export const PAGE_MIN = 1;
export const PAGE_MAX = Infinity;

type BaseQuery<Sort> = {
  page: number;
  count: number;
  sort: Sort;
};

export type ProjectsQuery = Simplify<BaseQuery<ProjectsSort> & { filter: ProjectsFilter }>;

export type ReleaseGroupsQuery = Simplify< BaseQuery<ReleaseGroupsSort> & { filter: ReleaseGroupsFilter }>;

export type ProjectsActionQuery = ProjectsByLocatorsQuery | ProjectsFilter & { locators: undefined } | { locators: 'all' };

export type ReleaseGroupsActionQuery = ReleaseGroupsByIdQuery | ReleaseGroupsFilter & { ids: undefined } | { ids: 'all' };

export type BulkProjectLabelQuery = ProjectsActionQuery & {
  labelId: number;
}

export type BulkProjectPolicyQuery = ProjectsActionQuery & {
  policyId: number;
}

export type BulkReleaseGroupPolicyQuery = ReleaseGroupsActionQuery & {
  policyId: number;
}
